import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, ITranslations, Lmid } from "@/types"
import { IGetFreightUnit } from "./Asset"
import AssetLocation, { IGetAssetLocationDto } from "./AssetLocation"

export interface IGetGlobalAssetOverviewAssetDto {
    articleId: Guid
    altArticleDescription?: string | null
    lmid: Lmid
    holderId: Guid
    isLabeled: boolean
    linkedToAssetCollection: boolean
    assetLocation: IGetAssetLocationDto
    constructionYear: number
    isOperational: boolean
    features?: ITranslations | null
    freightUnits?: IGetFreightUnit[] | null
    colorId?: Guid | null
    emissionLevel?: string | null
    measurementSystemId?: Guid | null
    length?: number | null
    width?: number | null
    height?: number | null
    volume?: number | null
    weight?: number | null
    quickCouplingSystem?: string | null
    connectionType?: string | null
    cuttingEdge?: boolean | null
    teeth?: boolean | null
    heavyDuty?: boolean | null
    locking?: string | null
    controlSystem?: string | null
    agility?: string | null
    listPrice?: number | null
    listPriceDate?: string | null
    assetCategory?: string | null
    division?: string | null
}

export class GlobalAssetOverviewAsset {
    articleId: Guid
    altArticleDescription?: string
    lmid: Lmid
    hoderId: Guid
    isLabeled: boolean
    linkedToAssetCollection: boolean
    assetLocation: AssetLocation
    constructionYear: number
    isOperational: boolean
    features?: ITranslations
    freightUnits: IGetFreightUnit[]
    colorId?: Guid
    emissionLevel?: string
    measurementSystemId?: Guid
    length?: number
    width?: number
    height?: number
    volume?: number
    weight?: number
    quickCouplingSystem?: string
    connectionType?: string
    cuttingEdge?: boolean
    teeth?: boolean
    heavyDuty?: boolean
    locking?: string
    controlSystem?: string
    agility?: string
    listPrice?: number
    listPriceDate?: Dayjs
    assetCategory?: string
    division?: string

    constructor(dto: IGetGlobalAssetOverviewAssetDto) {
        this.articleId = dto.articleId
        this.altArticleDescription = dto.altArticleDescription ?? undefined
        this.lmid = dto.lmid
        this.hoderId = dto.holderId
        this.isLabeled = dto.isLabeled
        this.linkedToAssetCollection = dto.linkedToAssetCollection
        this.assetLocation = new AssetLocation(dto.assetLocation)
        this.constructionYear = dto.constructionYear
        this.isOperational = dto.isOperational
        this.features = dto.features ?? undefined
        this.freightUnits = dto.freightUnits || []
        this.colorId = dto.colorId ?? undefined
        this.emissionLevel = dto.emissionLevel ?? undefined
        this.measurementSystemId = dto.measurementSystemId ?? undefined
        this.length = dto.length ?? undefined
        this.width = dto.width ?? undefined
        this.height = dto.height ?? undefined
        this.volume = dto.volume ?? undefined
        this.weight = dto.weight ?? undefined
        this.quickCouplingSystem = dto.quickCouplingSystem ?? undefined
        this.connectionType = dto.connectionType ?? undefined
        this.cuttingEdge = dto.cuttingEdge ?? undefined
        this.teeth = dto.teeth ?? undefined
        this.heavyDuty = dto.heavyDuty ?? undefined
        this.locking = dto.locking ?? undefined
        this.controlSystem = dto.controlSystem ?? undefined
        this.agility = dto.agility ?? undefined
        this.listPrice = dto.listPrice ?? undefined
        this.listPriceDate = dto.listPriceDate ? dayjs(dto.listPriceDate, "YYYY-MM-DD") : undefined
        this.assetCategory = dto.assetCategory ?? undefined
        this.division = dto.division ?? undefined
    }
}
